export const WARMUP_DURATIONS_SEC = [15, 30, 60];
export const WARMUP_START_PCT = { min: 30, max: 80, default: 50 };
/** Resume rules (PRD §7): <10 s continue; 10–30 s mini warm-up at 50% duration; >30 s full restart. */
export const WARMUP_RESUME = {
    continueUnderSec: 10,
    miniMaxSec: 30,
    miniDurationFactor: 0.5,
};
/**
 * Warm-up state machine. Linear ramp of effective WPM from startPct% to 100%
 * over durationSec. All times come from the engine's injected clock (B-2).
 * A pause under continueUnderSec leaves the ramp origin untouched — the ramp
 * keeps aging through the pause (prototype behavior port).
 */
export class WarmupController {
    kind = 'warmup';
    exclusive = true;
    startPct;
    durationSec;
    startedAtMs;
    pausedAtMs;
    cancelled = false;
    constructor(options = {}) {
        const pct = options.startPct ?? WARMUP_START_PCT.default;
        this.startPct = Math.min(WARMUP_START_PCT.max, Math.max(WARMUP_START_PCT.min, pct));
        this.durationSec = options.durationSec ?? 30;
    }
    /** Fresh session start: full ramp from startPct. */
    start(nowMs) {
        this.startedAtMs = nowMs;
        this.pausedAtMs = undefined;
        this.cancelled = false;
    }
    notePause(nowMs) {
        this.pausedAtMs = nowMs;
    }
    noteResume(nowMs) {
        if (this.cancelled || this.startedAtMs === undefined || this.pausedAtMs === undefined) {
            this.pausedAtMs = undefined;
            return;
        }
        const pausedForSec = (nowMs - this.pausedAtMs) / 1000;
        this.pausedAtMs = undefined;
        if (pausedForSec < WARMUP_RESUME.continueUnderSec) {
            return;
        }
        const durationMs = this.durationSec * 1000;
        if (pausedForSec <= WARMUP_RESUME.miniMaxSec) {
            // Mini warm-up: re-enter the ramp with 50% of the duration remaining.
            this.startedAtMs = nowMs - durationMs * (1 - WARMUP_RESUME.miniDurationFactor);
        }
        else {
            this.startedAtMs = nowMs;
        }
    }
    /** Manual speed change cancels warm-up until the next start(). */
    cancel() {
        this.cancelled = true;
    }
    isActiveAt(nowMs) {
        if (this.cancelled || this.startedAtMs === undefined)
            return false;
        return nowMs - this.startedAtMs < this.durationSec * 1000;
    }
    multiplierAt(nowMs) {
        if (!this.isActiveAt(nowMs))
            return 1.0;
        const elapsed = nowMs - (this.startedAtMs ?? 0);
        const progress = Math.max(0, elapsed / (this.durationSec * 1000));
        const startFraction = this.startPct / 100;
        return startFraction + (1 - startFraction) * progress;
    }
    snapshot(nowMs) {
        return {
            startPct: this.startPct,
            durationSec: this.durationSec,
            active: this.isActiveAt(nowMs),
            cancelled: this.cancelled,
        };
    }
}
//# sourceMappingURL=warmup.js.map